import React from 'react';
import useToken from '../hooks/useToken';
import useUser from '../hooks/useUser';
import { useState, useEffect, useMemo, useRef } from 'react';
import { SERVER_API_URL, MATCHMAKING_TIMEOUT } from '../config/Constants'
import Loading from '../components/Loading'
import ImageBackground from '../components/ImageBackground'
import { HEADER_HEIGHT } from '../config/Constants'
import { registerAnonymousUser } from '../containers/Login'
import GameUtils from '../utils/gameUtils'
import UserService from '../services/UserService'
import { useNavigate } from "react-router-dom";
//import { useCable } from '../contexts/CableProvider';
//import { useChannel } from '@aersoftware/react-use-action-cable';
import SoundDing from '../sounds/ding.mp3';
import Image from "../components/Image"
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ListGroup from 'react-bootstrap/ListGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb} from '@fortawesome/free-solid-svg-icons'
import HelpModal from '../components/HelpModal';
import AccountModal from '../components/AccountModal';
import InviteModal from '../components/InviteModal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LobbyChannel from '../channels/LobbyChannel'
import cable from '../channels/cable'
import Utils from '../utils/utils';
import Countdown from '../components/Countdown';

import {
  ScrollView,
  View,
  TextInput,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Alert,
  FlatList,
  ActivityIndicator,
  Dimensions
} from 'react-native';



export default function Main() {

  // const actionCable = useCable();
  // const { subscribe, unsubscribe, send } = useChannel(actionCable)

  const navigate = useNavigate();
  const { token, setToken } = useToken();
  const { user, setUser } = useUser();
  const [loading, setLoading] = useState(false);
  const [waitForGame, setWaitForGame] = useState(false);
  const [selectedTime, setSelectedTime] = useState(-1);
  const [availableGames, setAvailableGames] = useState([]);
  const [showHelp, setShowHelp] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const [waitingForUserToAccept, setWaitingForUserToAccept] = useState(false);
  const [playerCount, setPlayerCount] = useState("");
  const [pendingInvitations, setPendingInvitations] = useState([]);
  const [pendingFriendships, setPendingFriendships] = useState([]);

  useEffect(() => {
    const updatePlayerCount = () => {
      const now = new Date();
      const timeOfDay = (now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()) / 86400;
      
      const minPlayers = 13425442;
      const maxPlayers = 39430394;
      const range = maxPlayers - minPlayers;
      
      const phase = timeOfDay - 0.833; // Peak at 20:00
      const dailyVariation = (Math.cos(phase * Math.PI * 2) + 1) / 2;
      
      const timestamp = Math.floor(now.getTime() / 2100); 
      const noise = (Math.sin(timestamp * 12.9898) * 43758.5453) % 1;
      const smallNoise = (Math.abs(noise) - 0.5) * 0.04;
      
      const value = minPlayers + range * dailyVariation;
      const finalValue = Math.max(minPlayers, Math.min(maxPlayers, value + range * smallNoise));
      
      setPlayerCount(Math.floor(finalValue).toLocaleString());
    };
    
    updatePlayerCount();
    const interval = setInterval(updatePlayerCount, 2100);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (user && user.id) {
       GameUtils.getPendingInvitations().then(res => {
         if (res && res.data) setPendingInvitations(res.data);
       }).catch(e => console.error(e));
       UserService.getPendingFriends().then(res => {
         if (res && res.data) setPendingFriendships(res.data);
       }).catch(e => console.error(e));
    }
  }, [user]);

  const handleRespondInvitation = async (invId, status) => {
    try {
      const res = await GameUtils.respondToInvitation(invId, status);
      if (status === 'accept' && res.data.game_id) {
         navigate(`/games/${res.data.game_id}/invitation`);
      } else {
         setPendingInvitations(pendingInvitations.filter(i => i.id !== invId));
      }
    } catch(e) {
      console.error(e);
      alert("Error responding to invitation");
    }
  }

  const handleAcceptFriend = async (friendId) => {
    try {
      await UserService.acceptFriend(friendId);
      setPendingFriendships(pendingFriendships.filter(f => f.id !== friendId));
    } catch(e) { console.error(e); }
  }

  const handleDenyFriend = async (friendId) => {
    try {
      await UserService.denyFriend(friendId);
      setPendingFriendships(pendingFriendships.filter(f => f.id !== friendId));
    } catch(e) { console.error(e); }
  }

  const audioDing = useMemo(() => new Audio(SoundDing), []);
  const hasDinged = useRef(false)
  const lastPingAt = useRef(0);
  const isConnected = useRef(false);
  const lastInteractionAt = useRef(0);
  const needRefresh = useRef(false);
  const pingingTimer = useRef(null);
  const waitForGameTime = useRef(-1);
  const waitForGameRef = useRef(null);
  const availableGamesRef = useRef([]);
  
  const handleReceived = (data) => {
   //  alert(JSON.stringify(data) + '>>' + JSON.stringify(user))
    // alert('handleReceived' + JSON.stringify(data) + '>>' + user.id)
    console.log(data) // response received from rails

    var user = localStorage.getItem('user') || null;
    if (!user || user === 'undefined' || user === 'null') {
      //  alert(JSON.stringify(user))
      return null
    }
    user = JSON.parse(localStorage.getItem('user'));


    if (!data || !data.action || !user)
      return

    if (data.action == 'game_starts') {
      // alert('nav')
      removeFromAvailableGamesWithUsers(data)
      if (data.player1_id == user.id || data.player2_id == user.id) {
        try {
          if (audioDing)
            audioDing.play()
        }
        catch (e) {
        }
        navigate("/game/" + data.game_id);
      }
      else {
        //remove from availableGames
       // removeFromAvailableGames({unique_id: data.unique_id})
      }

    }
    if (data.action == 'game_new_bot') {
     // alert(JSON.stringify(availableGamesRef.current))
      for (var i = 0; availableGamesRef.current && i < availableGamesRef.current.length; i++) {
        if (availableGamesRef.current[i].user_id == data.user_id) {
          availableGamesRef.current[i].is_playing_a_bot_now = true
          break
        }
      }
      setAvailableGames([...availableGamesRef.current])
    }
    // alert(user.id + '  ' + data.user_id)
    // alert(JSON.stringify(data))
    if (data.action === 'new_invitation' && data.receiver_id === user?.id) {
      setPendingInvitations(prev => [...prev, data]);
      if (!hasDinged.current) {
        try { hasDinged.current = true; if (audioDing) audioDing.play(); } catch (e) { }
      }
    }

    if (data.action == 'game_new' && (data.user_id != user.id)) {
      //check if not already in availableGames
      var alreadyInAvailableGames = availableGamesRef.current.filter((game) => game.unique_id == data.unique_id)
      if (alreadyInAvailableGames.length === 0) {
//alert(data.time + '   ' +  waitForGameType.current + '   ' + waitForGame)
        if (waitForGameRef.current && waitForGameTime.current != data.time && data.time != -1)
          return
        data.addedAt = Date.now()
        availableGamesRef.current.push(data)
        setAvailableGames([...availableGamesRef.current])

        setTimeout(() => {
          removeFromAvailableGames(data)
        }, MATCHMAKING_TIMEOUT * 1000)
      }

      if (!hasDinged.current) {
        try {
          hasDinged.current = true
          if (audioDing)
            audioDing.play()
        }
        catch (e) {
        }
      }
    }

  }

  useEffect(() => {
    function handleMouseMove(event) {
      //console.log(`Mouse moved: X:${event.clientX}, Y:${event.clientY}`);
      lastInteractionAt.current = Date.now()
    }

    window.addEventListener('mousemove', handleMouseMove);

    // Be sure to remove event listener when the component unmounts
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount



  /*useEffect(() => {
    subscribe({
      channel: 'LobbyChannel',
    }, {
      received: (data) => handleReceived(data),
      // Custom callbacks can be added for 'initialized', 'connected', and 'disconnected'
    })
    return () => {
      unsubscribe()
    }
  }, [])*/

  const checkPing = () => {

    console.log("checking ping", lastPingAt.current, Date.now())
    //if haven't had a ping since 10 s, we refresh the page
    if (lastPingAt.current < Date.now() - (10 * 1000)) {
      console.log('no ping, reloading')


      var obj = null
      var str = localStorage.getItem('reloadInfoMain')
      if (str)
        obj = JSON.parse(str)

      //resetting to 0
      if (obj && obj.lastReload && obj.lastReload < Date.now() - (15 * 60 * 1000)
        && lastInteractionAt.current > Date.now() - (10 * 60 * 1000)) {

        obj.lastReload = Date.now()
        obj.nbReload = 0
        localStorage.setItem('reloadInfoMain', JSON.stringify(obj))
        window.location.reload()
      }
      ////prevents flooding the server
      else if (obj && obj.nbReload && obj.nbReload > 5) {
        console.log('too many reloads')
      }
      else if (lastInteractionAt.current > Date.now() - (10 * 60 * 1000)) {
        if (!obj)
          obj = {}
        if (!obj.nbReload)
          obj.nbReload = 0
        obj.nbReload++
        obj.lastReload = Date.now()
        localStorage.setItem('reloadInfoMain', JSON.stringify(obj))
        window.location.reload()
      }


    }
  }




  useEffect(() => {


    const timer = setInterval(() => checkPing(), 10000)


    // Cleanup function
    return () => {
      clearInterval(timer);
    }
  }, []);

  /*

  useEffect(() => {

    const subscription = consumer.subscriptions.create({
      channel: 'LobbyChannel',

    }, {
      connected: () => {
        if (needRefresh.current) {
          window.location.reload();
          //checkIfGameHasStarted()
          needRefresh.current = false
        }
        isConnected.current = true
        lastPingAt.current = Date.now()

        if (pingingTimer.current)
          clearInterval(pingingTimer.current)
        pingingTimer.current = setInterval(() => subscription.perform('message', { text: 'pinging' }), 10000)

      },
      disconnected: () => {
        if (pingingTimer.current)
          clearInterval(pingingTimer.current)
         console.log('disconnected')
         isConnected.current = false
         needRefresh.current = true

        },
      received: data => handleReceived(data),
      ping: () => { lastPingAt.current = Date.now() },
    })

    // Cleanup function
    return () => {
    //  if (isConnected.current) {
      //  isConnected.current = false
        consumer.subscriptions.remove(subscription);
     // }
    }

  }, []); // Notice the empty array here. This tells React to run the effect only once, thus mimicking componentDidMount.

*/

useEffect(() => {

  const channel = new LobbyChannel({ })


// Subscribe to the server channel via the client.
cable.subscribe(channel) // return channel itself for chaining



// Handle incoming messages
let unbindMessage = channel.on('message', msg =>  {
// alert(JSON.stringify(msg))
handleReceived(msg)
console.log(`${msg.name}: ${msg.text}`)}
)


let unbindPing = cable.on('keepalive', msg =>  {
  lastPingAt.current = Date.now() })


  // Cleanup function
  return () => {
    // Unsubscribe from the channel (results in a 'close' event)
    channel.disconnect()
    unbindMessage()
    unbindPing()
  }

}, []);


  const checkIfGameHasStarted = async () => {

    try {
      var res = await GameUtils.getHistory()
      if (res && res.data) {

      }
    }
    catch (e) {
    //  alert(e.message)
      console.error(e)

      return
    }
  }


  const startGame = async (withBot = false) => {

    if (!withBot) {
      try {
        var res = await GameUtils.findPartner({ type: 0, time: selectedTime })
        setLoading(false)
        waitForGameRef.current = true
        setWaitForGame(true)
        waitForGameTime.current = selectedTime

        // The API drops the matchmaking request, so we reset the UI to match
        setTimeout(() => {
          if (waitForGameRef.current) {
            waitForGameRef.current = false
            setWaitForGame(false)
          }
        }, (MATCHMAKING_TIMEOUT * 1000) + 1000)
      }
      catch (e) {
        alert(e.message)
        setLoading(false)
        waitForGameRef.current = false
        setWaitForGame(false)
      }
    }
    else {
      try {
        var res = await GameUtils.createBotGame({ type: 0, time: -1 })
        // alert(JSON.stringify(res))

        setLoading(false)

       // if (waitForGame)
        //  window.open("/game/" + res.data.id + '?isBotGame=true' + (waitForGame ? '&waitingForGameWithTime=' + waitForGameTime.current : ''), '_blank');
        //else
          navigate("/game/" + res.data.id + '?isBotGame=true' + (waitForGame ? '&waitingForGameWithTime=' + waitForGameTime.current : ''));
      }
      catch (e) {
        alert(e.message)
        setLoading(false)
      }
    }

  }

  const loginIfNeededAndStartGame = async (user, withBot = false) => {
    setLoading(true)
    if (!token) {
      var data = await registerAnonymousUser(user)

      if (!data || !data.auth_token) {
        alert('An error occured')
        return
      }
      setToken(data.auth_token);
      setUser(data.user)

      ///alert('setting user ' +JSON.stringify(user) + '>>' + JSON.stringify( localStorage.getItem('user')))
      navigate('/tuto')

      // alert(JSON.stringify(res))
    }
    else {

      await startGame(withBot)

      // alert(JSON.stringify(res))
    }
  }

  const removeFromAvailableGames = (availableGame) => {
    if (!availableGamesRef.current)
      return
    //remove from availableGames
    var newAvailableGames = availableGamesRef.current.filter((game) => game.unique_id != availableGame.unique_id)
    setAvailableGames(newAvailableGames)
  }

  const removeFromAvailableGamesWithUsers = (gameStarting) => {
    if (!availableGamesRef.current)
      return
    //remove from availableGames
    var newAvailableGames = availableGamesRef.current.filter((game) => game.id === gameStarting.player1_id || game.id === gameStarting.player2_id)
    setAvailableGames(newAvailableGames)
  }
  /*
    const isWaitingForGame = () => {
      for (var i = 0; i < availableGames.length; i++) {
        if (availableGames[i].user_id == user.id)
          return true
      }
    }*/

  const hasGameReadyToJoin = () => {
    for (var i = 0; i < availableGamesRef.current.length; i++) {
      if (availableGamesRef.current[i].user_id != user.id)
        return true
    }
    return false
  }


  const acceptGame = async (availableGame) => {

    setLoading(true)
    if (availableGame.is_playing_a_bot_now) {

      
      try {
        var res = await GameUtils.askPlayerInBotGame(availableGame.id, availableGame.user_id)
        setLoading(false)
        if (res.data.error && res.data.error == 'already_started') {
          alert("Another user already joined this game")
  
          removeFromAvailableGames(availableGame)
          return
        }
        setTimeout(() => {
          availableGamesRef.current = []
          setAvailableGames([])
          setWaitingForUserToAccept(false)
          setWaitForGame(false)
        
        }, 15000)
          
      }
      catch (e) {
        alert(e.message)
        setLoading(false)
      }
      setWaitingForUserToAccept(true)
      return
    }
    

    try {
      var res = await GameUtils.acceptGame(availableGame.id, availableGame.user_id)
      setLoading(false)
      if (res.data.error && res.data.error == 'already_started') {
        alert("Another user already joined this game")

        removeFromAvailableGames(availableGame)
        return
      }
    }
    catch (e) {
      alert(e.message)
      setLoading(false)
    }
    // alert('going to game ' + JSON.stringify(data))
    navigate("/game/" + res.data.id);
    // alert(JSON.stringify(res))

  }

  const renderButton = (text, onPress, variant) => {
    return (
      <Button
        className='mt-1 mb-4'
        onClick={() => {
          console.log('Start Game')
          onPress()
        }}
        variant={variant}
      >{text}</Button>
    )
  }

  const renderAvailableGames = () => {

    if (waitingForUserToAccept) {
      return (
        <View style={{flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
          <Text style={{color:'#fff'}}>Waiting for other player confirmation, cancel in: </Text>
        <Countdown />
        </View>
      )
    }
    if (availableGames.length === 0)
      return null

    return (
      <View style={{
        position: 'absolute',
        top: 20,
        zIndex: 1000,
        justifyContent: 'center',
        alignItems: "center",
        flexDirection: 'column',
        width: "100%",
        padding: 5,
        pointerEvents: 'box-none'
      }} >
        {
          availableGames.map((availableGame) => {
            return (
              <Button
                size="sm"
                key={availableGame.unique_id}
                onClick={() => acceptGame(availableGame)}
                variant="warning"
                className="mt-1 mb-1 shadow"
                style={{
                  backgroundColor: "#FFBA0E",
                  borderColor: "#A97B09",
                  color: "black",
                  fontWeight: "bold",
                  opacity: 0.95
                }}
              >
                {availableGame.name} wants to start a {availableGame.time == -1 ? 'Any' : Utils.getHumanTime(availableGame.time)} game
              </Button>
            )
          })
        }
      </View>

    )
  }

  if (loading) {
    return (<Loading />)
  }

  return (


    <Container
    >

      {/* <Text>My user id: {user ? user.id : 'not connected'}</Text> */}

      {loading && <Loading />}

      <HelpModal show={showHelp} onHide={() => setShowHelp(false)} />
      <InviteModal show={showInvite} onHide={() => setShowInvite(false)} />
      <AccountModal
          show={showAccount}
          onHide={() => setShowAccount(false)}
          onPlay={(user) => {
              console.log('Start Game')
              setShowAccount(false)
              loginIfNeededAndStartGame(user)}
      }/>
      <View id="lobbyContainer"  >
      </View>

      <View style={{ position: 'relative', justifyContent: 'center', alignItems: "flex-end", flexDirection: "row" , marginTop: -12, marginBottom: 16}} >
        {renderAvailableGames()}
        <Image source={"/imgs/pion-big.png"} style={{ marginRight: 4, width: 110, height: 220 }} />
        <Image source={"/imgs/pion-small.png"} style={{ marginLeft: 4, width: 110, height: 220 }} />
      </View>

      <View style={{ justifyContent: 'center', alignItems: 'center', marginBottom: 20 }}>
         <Text style={{ color: '#FFBA0E', fontSize: 16, fontWeight: 'bold' }}>{playerCount} players currently playing</Text>
      </View>

      {pendingInvitations && pendingInvitations.length > 0 ? (
        <View style={{ width: '100%', alignItems: 'center', marginBottom: 20 }}>
           <Text style={{ color: 'white', fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>Pending Challenges</Text>
           {pendingInvitations.map(inv => (
              <View key={inv.id} style={{ flexDirection: 'row', backgroundColor: '#333', padding: 10, borderRadius: 8, marginBottom: 8, alignItems: 'center', width: '90%', maxWidth: 400 }}>
                 <View style={{ flex: 1 }}>
                    <Text style={{ color: 'white', fontSize: 16 }}>{inv.sender_name} (ELO: {inv.sender_elo})</Text>
                    <Text style={{ color: '#aaa', fontSize: 14 }}>{Utils.getHumanTime(inv.time_control)} game</Text>
                 </View>
                 <View style={{ flexDirection: 'row' }}>
                    <Button variant="success" size="sm" style={{ marginRight: 8 }} onClick={() => handleRespondInvitation(inv.id, 'accept')}>Accept</Button>
                    <Button variant="danger" size="sm" onClick={() => handleRespondInvitation(inv.id, 'reject')}>Reject</Button>
                 </View>
              </View>
           ))}
        </View>
      ) : null}

      {pendingFriendships && pendingFriendships.length > 0 ? (
        <View style={{ width: '100%', alignItems: 'center', marginBottom: 20 }}>
           {pendingFriendships.slice(0, 1).map(f => (
              <View key={f.id} style={{ flexDirection: 'row', backgroundColor: '#e2f3f5', padding: 10, borderRadius: 8, marginBottom: 8, alignItems: 'center', width: '90%', maxWidth: 400 }}>
                 <View style={{ flex: 1 }}>
                    <Text style={{ color: '#333', fontSize: 16, fontWeight: 'bold' }}>{f.name}</Text>
                    <Text style={{ color: '#555', fontSize: 14 }}>wants to be your friend!</Text>
                 </View>
                 <View style={{ flexDirection: 'row' }}>
                    <Button variant="success" size="sm" style={{ marginRight: 8 }} onClick={() => handleAcceptFriend(f.id)}>Accept</Button>
                    <Button variant="danger" size="sm" onClick={() => handleDenyFriend(f.id)}>Deny</Button>
                 </View>
              </View>
           ))}
        </View>
      ) : null}

      <View style={{ flex: 1, justifyContent: 'center'  , paddingBottom: 44}} >
        {!waitForGame &&
          <View style={{ flex: 1, justifyContent: 'center', alignItems: "center", width: "100%", position: 'relative', zIndex: 1000 }} >
            <Dropdown
              className="bg-transparent"
              style={{backgroundColor: undefined, borderColor: undefined, color: "white"}}
              onSelect={
                (eventKey) => {
                  console.log('selected time ' + eventKey)
                  setSelectedTime(eventKey)

                }

              }>
              <DropdownButton
                as={ButtonGroup}
                id={`dropdown-time`}
                drop={"end"}
                style={{backgroundColor: undefined, borderColor: undefined, color: "white", zIndex:500}}
                variant={"link"}
                title={"Selected time: " + (selectedTime === -1 ? 'Any' : Utils.getHumanTime(selectedTime)) + " " }
              >
                <Dropdown.Item eventKey="-1" active={selectedTime == -1} >Any</Dropdown.Item>
                <Dropdown.Item eventKey="60" active={selectedTime == "60"} >1 min</Dropdown.Item>
                <Dropdown.Item eventKey="180" active={selectedTime == "180"}>3 min</Dropdown.Item>
                <Dropdown.Item eventKey="600" active={selectedTime == "600"}>10 min</Dropdown.Item>
                <Dropdown.Item eventKey="1800" active={selectedTime == "1800"}>30 min</Dropdown.Item>
                <Dropdown.Item eventKey="3600" active={selectedTime == "3600"}>1 h</Dropdown.Item>
                <Dropdown.Item eventKey="604800" active={selectedTime == "604800"}>One week</Dropdown.Item>
              </DropdownButton>
            </Dropdown>
          </View>
        }
        {
          !waitForGame &&
          renderButton(
            "Start Game",
            () => {
              if (!user || !user.id) {
                setShowAccount(true)
                return
              } else {
                loginIfNeededAndStartGame()
              }
            },
            "warning"
          )
        }
        {
          waitForGame &&
          <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 10, marginBottom: 20}}>
            <ActivityIndicator size="small" color="#FFBA0E" style={{marginRight: 12}} />
            <Text style={{color: '#FFBA0E', fontSize: 16, fontWeight: 'bold'}}>Searching for a match...</Text>
          </View>
        }



        {
          renderButton(
            "Start Game vs Bot",
            () => {
              if (!user || !user.id) {
                setShowAccount(true)
                return
              } else {
                loginIfNeededAndStartGame(user, true)
              }
             },
            "dark"
          )
        }
        {user && user.id && (
          <View style={{ flexDirection: 'row', justifyContent: 'flex-end', width: '100%', paddingRight: 20, marginBottom: 12 }}>
            <Button 
              size="sm" 
              variant="danger" 
              onClick={() => setShowInvite(true)}
              style={{ fontSize: '0.8rem', opacity: 0.8 }}
            >
              Invite an enemy
            </Button>
          </View>
        )}
        <Button id="helpLink" onClick={() => setShowHelp(true)}
            variant="link"><FontAwesomeIcon icon={faLightbulb} />  What is SumoChess?</Button>
      </View>

    </Container>



  );
}

